import { useMemo, useRef, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import emptyScreenerSvg from './emptyScreenerSvg.svg'
import ScreenerFiltersModal from './ScreenerFiltersModal'
import { useScreenerContext} from '../context/useScreenerContext'
import useWindowSize from '../../../hooks/useWindowSize'
import { Skeleton, Typography, Paper } from '@mui/material'
import styles from './Screener.module.scss'
import { Button } from '@mui/material'
import { FilterList } from '@mui/icons-material'

const cellWidth = 220

const ScreenerTable = ({columns, rows = [], isLoading, isEmpty}) => {
  const { handleUpdateFilters, name } = useScreenerContext()
  const [ rowsPerPage, setRowsPerPage ] = useState(10)
  const tableRef = useRef(null)
  const size = useWindowSize()

  const tableHeight = useMemo(() => rowsPerPage*52 ,[rowsPerPage])

  const tableCellWidth = useMemo(() => {
    const tableWidth = tableRef?.current?.offsetWidth
    return size && (!tableWidth || ((tableWidth / columns.filter(column => !column.hide).length) > cellWidth)? {flex:1} : {width: cellWidth})
  },[tableRef, columns, size])
  
  const styledColumns = useMemo(() => 
    columns.map(
      column => (
        {...column,
          headerAlign: 'center',
          ...(!column.width && tableCellWidth)
        })) 
  ,[columns, tableCellWidth])

  const onPageSizeChange = (number) => setRowsPerPage(number)
  const FilterButton = () =>(
    <Button 
        onClick={openFiltersModal}
        startIcon={<FilterList/>}
        className={styles['btn']}
    >Filters</Button>
  )

  const emptyTable = () => (
    <>
      <Message 
        title='Add a filter to view data' 
        message={`Narrow your screening by applying \n one or more of the filters`} 
        tableHeight={tableHeight}
      />
    </>
  )
  
  
  const [ open, setOpen ] = useState(false)

  const openFiltersModal = () => setOpen(true)

  const closeFilterModal = () => setOpen(false)

  const loading = (
    <div className={styles['skeleton']}>
      <Skeleton variant="rect" width={tableRef?.current?.offsetWidth} height={tableHeight} />
    </div>
  )

  const noDataTable = () => (
    <>
    <Message 
      title={`We were unable to find companies \n based on your filter.`}
      message={`Remove one or more of the filters to \n narrow your search`} 
      tableHeight={tableHeight}
    />
    
    </>
  )

  const cell = props =>  {
    const { width, height, value, children } = props 
    return <div style={{width, height}} className={`${styles['table-cell']}`} align="center">
          {children ?? value}
      </div>
  }

  const table = (
      <DataGrid 
          rows={rows}
          columns={styledColumns}
          components={{
            NoRowsOverlay: isEmpty ? emptyTable : noDataTable,
            Cell: cell,
          }}
          classes={{
            root: styles['root'],
            columnHeaders: styles['column-headers'],
          }}
          rowsPerPageOptions={[10,25,50,100]}
          autoHeight = {rows.length>0?true:false}
          loading={isLoading}
          pageSize={rowsPerPage}
          onPageSizeChange={onPageSizeChange}
          disableSelectionOnClick
        />
  )
  const Message = ({title, message, tableHeight}) => {
    return (
      <div style={{ height: `${tableHeight-116}px`}} className={styles['empty-table']}>
        <div className={styles['msg']}>
            <img src={emptyScreenerSvg} alt="No data"/>
            <Typography variant="h3"> {title} </Typography>
            <FilterButton />
            <Typography> {message} </Typography>
        </div>
      </div>
    )
  }

  return (
    <>
      <Paper ref={tableRef} elevation={7}>
        {isLoading ? loading : table}
      </Paper>
      <ScreenerFiltersModal open={open} handleClose={closeFilterModal} title={name} handleUpdateFilters={handleUpdateFilters}/>
    </>
  )
}


 export default ScreenerTable